var chunkToChildrenMap = {
	"1067": [
		5450,
		6773,
		7488
	],
	"1911": [
		5450,
		6773,
		7488
	],
	"3839": [
		1314,
		9128,
		3009,
		2083,
		6077,
		7763,
		3668,
		9832,
		2128,
		6318,
		8992,
		9656,
		7752,
		6535,
		8274,
		1620,
		1640,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));